import React, { useRef } from 'react';
import { useToast } from 'react-native-toast-notifications';
import { useAppDispatch } from '../../../hooks';
import { Page, showToast } from '../../../components';
import { Input, Button, FormContainer, ButtonContainer, InputRefProps } from '../../../components/Form';
import authService from '../../../services/authService';
import { setLoading } from '../../../store/portal/portalActions';

export const MySettingChangePassword = ({ navigation }: any) => {
  const toast = useToast();
  const dispatch = useAppDispatch();

  const inputOldPassword = useRef<InputRefProps>(null);
  const inputConPassword = useRef<InputRefProps>(null);
  const inputNewPassword = useRef<InputRefProps>(null);

  const doSaveBtn = async () => {
    const oldPassword = inputOldPassword.current?.value;
    const conPassword = inputConPassword.current?.value;
    const newPassword = inputNewPassword.current?.value;

    if (oldPassword && newPassword) {
      if (conPassword !== oldPassword) {
        showToast(toast, { message: 'Confirm password must match with password', type: 'error' });
        return;
      }

      dispatch(setLoading(true));
      let res = await authService.changePassword(oldPassword, newPassword);
      if (res.status === 200 && res.data.resultCode === 0) {
        dispatch(setLoading(false));
        showToast(toast, { message: 'New password updated', type: 'success' });
      }
    } else {
      showToast(toast, { message: 'Please key in old password and new password', type: 'error' });
    }
  };

  return (
    <Page title={'Change Password'}>
      <FormContainer title="">
        <Input label={'Password'} id="password" schemaContext={{ isEdit: true }} ref={inputOldPassword} />

        <Input label={'Confirm Password'} id="newPassword" schemaContext={{ isEdit: true }} ref={inputConPassword} />

        <Input label={'New Password'} id="newPassword" schemaContext={{ isEdit: true }} ref={inputNewPassword} />

        <ButtonContainer>
          <Button onPress={() => doSaveBtn()}>Save</Button>
        </ButtonContainer>
      </FormContainer>
    </Page>
  );
};
